import React, { Component } from 'react'
import { Skeleton } from 'antd';

export class Loading extends Component {
  render() {
    return (
      <div className="loading-page">
        <Skeleton active paragraph={{ rows: 4 }}/>
        <Skeleton.Button active />
      </div>
    )
  }
}

export default Loading
